import { render, staticRenderFns } from "./bargain.vue?vue&type=template&id=17b1d2a0&scoped=true"
import script from "./bargain.vue?vue&type=script&lang=js"
export * from "./bargain.vue?vue&type=script&lang=js"
import style0 from "./bargain.vue?vue&type=style&index=0&id=17b1d2a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b1d2a0",
  null
  
)

export default component.exports